import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "components/CustomButtons/Button.js";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import { WithApp } from "contexts/appContext";

import {
  Marker,
  InfoWindow
} from "@react-google-maps/api";
import { wsFindBy } from "services/WService";
import GoogleMapCustom from "components/Tvendo/Common/GoogleMapCustom";

const useStyles = makeStyles(() => ({
  closeButton: {
    float: "right"
  },
  h5: {
    color: "black",
    fontWeight: "500",
    marginLeft: "20px"
  },
  divStyle: {
    padding: "4px",
    listStyle: "none",
    background: "#c8f7ec",
    borderRadius: "5px",
    "& span": {
      fontSize: "15px",
      fontWeight: 500
    }
  }
}));

export default WithApp(function ModalMarkedDay(props) {
  const classes = useStyles();

  const [mapCenter, setMapCenter] = useState({
    lat: -14.07543457346045,
    lng: -75.73423487506565
  });

  const [openInfo, setOpenInfo] = useState(false);
  const [infoData, setInfoData] = useState({});

  const { showModalMarkedDay, setShowModalMarkedDay, date } = props;
  const route = props.route;

  const handleClose = () => {
    setShowModalMarkedDay(false);
  };

  const [markedDays, setMarkedDays] = useState([]);

  async function getMarkedDays() {
    let response = await wsFindBy(
      "base/customer-route/marked-of-day/" + route.route_id,
      date
    );
    if (response.success) {
      setMarkedDays(response.data);
      setMapCenter({
        lat: parseFloat(response.data[0].latitude),
        lng: parseFloat(response.data[0].longitude)
      });
    }
  }

  useEffect(() => {
    if (showModalMarkedDay) {
      getMarkedDays();
    }
  }, [showModalMarkedDay]);

  return (
    <Dialog
      open={showModalMarkedDay}
      onClose={handleClose}
      fullWidth
      maxWidth="lg"
    >
      <DialogTitle>
        {!!route ? route.route_description : ""} - {markedDays.length} direcciones
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <GoogleMapCustom
          mapContainerStyle={{
            width: "100%",
            height: "100%",
            minHeight: "700px"
          }}
          zoom={13}
          center={mapCenter}
          options={{
            disableDoubleClickZoom: true
          }}
          onClick={() => {
            setOpenInfo(false);
          }}
        >
          {markedDays.map((markedD, i) => {
            return (
              <Marker
                key={i}
                position={{
                  lat: parseFloat(markedD.latitude),
                  lng: parseFloat(markedD.longitude)
                }}
                onClick={() => {
                  setOpenInfo(true);
                  setInfoData(markedD);
                }}
              />
            );
          })}
          {openInfo ? (
            <InfoWindow
              position={{
                lat: parseFloat(infoData.latitude),
                lng: parseFloat(infoData.longitude)
              }}
              onCloseClick={() => {
                setOpenInfo(false);
                setInfoData({});
              }}
              options={{
                pixelOffset: {
                  width: 0,
                  height: -25,
                },
              }}
            >
              <div className={classes.divStyle}>
                <li>
                  <span>Nombre: </span>
                  {infoData.business_name}
                </li>
                <li>
                  <span>Dir: </span>
                  {infoData.base_address_description}
                </li>
              </div>
            </InfoWindow>
          ) : undefined}
        </GoogleMapCustom>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          color={props.themeContext.buttonColorDanger}
          size="sm"
        >
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
});
